import React, { useState } from 'react';
import PT from 'prop-types';
import {
  Box,
  Button,
  colors,
  spacing,
  useI18nContext,
} from '@procore/core-react';
import styled from 'styled-components';
import { List } from '@procore/core-icons';
import SearchBar from '@/react/components/SearchBar';
import SupportMenu from '@/react/components/SupportMenu';
import ProfileBox from '@/react/components/ProfileBox';
import { useAppContext } from '@/react/context/AppContext';
import { useMediaQuery } from '@/react/hooks/useMediaQuery';
import MobileMenu from '@/react/components/MobileMenu';
import BrandingHeader from './BrandingHeader';

const Header = styled.header`
  position: sticky;
  top: 0;
  right: 0;
  left: 0;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.gray90};
  padding: 0 ${spacing.lg}px;
  width: 100%;
  z-index: 10000;
`;

const NavContainer = styled(Box)`
  @media (min-width: 768px) {
    flex: 1;
  }
`;

const Navbar = ({ isSearchVisible }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isTablet = useMediaQuery('(max-width: 992px)');
  const isDesktop = useMediaQuery('(min-width: 1201px)');
  const i18n = useI18nContext();
  const { header } = useAppContext();
  const { marketplaceBasePath } = header;

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <>
      <Header data-testid="app-navbar">
        <NavContainer
          display="flex"
          padding="md"
          alignItems="center"
          justifyContent="space-between"
          gap="md"
        >
          <BrandingHeader
            isDesktop={isDesktop}
            title={i18n.t('global.appMarketplace')}
            marketplaceBasePath={marketplaceBasePath}
          />

          {!isTablet && isSearchVisible && (
            <Box flex={12} data-testid="search-desktop">
              <SearchBar />
            </Box>
          )}

          {!isMobile ? (
            <Box display="inline-flex" gap="md" alignItems="center">
              <SupportMenu />
              <ProfileBox />
            </Box>
          ) : (
            <Button
              data-testid="toggle-mobile-menu"
              variant="tertiary"
              icon={<List />}
              onClick={toggleMenu}
            />
          )}
        </NavContainer>

        {isTablet && isSearchVisible && (
          <Box paddingBottom="md" data-testid="search-tablet">
            <SearchBar />
          </Box>
        )}
      </Header>
      {isMobile && <MobileMenu toggleMenu={toggleMenu} isOpen={isMenuOpen} />}
    </>
  );
};

Navbar.propTypes = {
  isSearchVisible: PT.bool.isRequired,
};

export default Navbar;
